import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www-local/frontend/lides/lides-sk-01/app/components/wishlist/WishlistContent.jsx");
